import Box from '@mui/material/Box';
import Button from '@mui/material/Button';
import Dialog from '@mui/material/Dialog';
import DialogActions from '@mui/material/DialogActions';
import DialogContent from '@mui/material/DialogContent';
import TextCopyInput from '../../base-ui/components/TextCopyInput';
import { Booking } from '../../domain/booking';
import SpinnerIcon from '../../main/component/icon/SpinnerIcon';
import useAlterBookingState from '../hooks/useAlterBookingState';

/* eslint-disable no-template-curly-in-string */

const ReviewDialog = ({
    booking,
    onClose,
    onSuccess,
}: {
    booking: Booking;
    onClose(): void;
    onSuccess?: () => void;
}) => {
    const [alterBookingState, { loading: alterBookingStateLoading }] =
        useAlterBookingState(booking.id);

    if (alterBookingStateLoading) {
        return <SpinnerIcon />;
    }

    return (
        <Dialog open>
            <DialogContent>
                <Box display="flex" flexDirection="column" gap={2}>
                    <TextCopyInput
                        type="textarea"
                        value={"${firstName}'s group were good guests. I can recommend them to my fellow hosts without any hesitation.".replace(
                            '${firstName}',
                            booking.guests[0].firstName
                        )}
                    />
                    <Button
                        variant="contained"
                        onClick={() => {
                            window.open(
                                `https://www.airbnb.co.uk/hosting/reservations/details/${booking.reference}`
                            );
                        }}
                    >
                        Open booking
                    </Button>
                </Box>
            </DialogContent>
            <DialogActions>
                <Box display="flex" gap={2}>
                    <Button variant="contained" onClick={onClose}>
                        Close
                    </Button>
                    <Button
                        variant="contained"
                        onClick={() => {
                            alterBookingState({
                                variables: {
                                    id: booking.id,
                                    fields: { hasReview: true },
                                },
                            })
                                .then(() => {
                                    onSuccess?.();
                                })
                                .catch(error => {
                                    throw error;
                                })
                                .finally(() => {
                                    onClose();
                                });
                        }}
                    >
                        Mark as sent
                    </Button>
                </Box>
            </DialogActions>
        </Dialog>
    );
};

export default ReviewDialog;
